export default "/images/vendor/flag-icon-css/flags/4x3/gb-nir.svg?aec8ba24bb3b3183323ace263387df0a";